module.exports = __webpack_public_path__ + "img/kv_geometry.81c6eb6c.png";